// import { privateRequest } from "../axios";
import type { User, ApiResponse } from "@/types/user";
import { getCurrentUser } from "@/lib/utils";

export interface UserData {
  CityId: number;
  CountryId: number,
  From: number,
  IsActive: boolean,
  ManagerId: string,
  RoleIds: string,
  SearchText: string,
  StateId: number;
  To: number,
  departmentIds: string,
  designationIds: string,
  branchIds: string,
  UserId? : number
};

const ENDPOINTS = {
  USER_SETTING: "api/GetUserSetting",
  USER_GLOBAL_SETTING: "/api/GetUserGlobalSetting",
  USER_CHECKOUT: "/api/CheckOut",
  USER_CHECKIN: "/api/CheckIn",
  USER_WORKSTATION: "/api/WorkStation",
  USER_DATA : '/api/Users',
  ASSIGN_TEAM : '/api/CRM/AssignTeam',
  COUNTRY_LIST : '/api/GetCountryList',
  DEPARTMENT_LIST : 'api/Departments',
  DESIGNATION_LIST : 'api/Designations',
  BRANCH_LIST : '/api/Branch',
  ROLES : '/api/Roles',
  USER_DETAILS : '/api/v1/Users',
  NOT_TEAM_MEMBER : "/api/CRM/NotTeamMembers",
  DEACTIVATE : "api/Users/${Id}/Deactivate",
  ASSIGN_MANAGER : "api/CRM/UpdateManager"
};

const getUsersSetting = async (): Promise<any> => {
  const response = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.USER_SETTING}?userId=${getCurrentUser()?.userId}`
  );
  return response;
};
// export const getUserGlobalSetting = async (): Promise<any> => {
//   const response = await privateRequest.get(
//     `${ENDPOINTS.USER_GLOBAL_SETTING}?userId=${getCurrentUser()?.userId}`
//   );
//   return response;
// };
// export const checkout = async (payload: any): Promise<any> => {
//   const response = await privateRequest.post(
//     `${ENDPOINTS.USER_CHECKOUT}`,
//     payload
//   );
//   return response;
// };
// export const Checkin = async (payload: any): Promise<any> => {
//   const response = await privateRequest.post(
//     `${ENDPOINTS.USER_CHECKIN}`,
//     payload
//   );
//   return response;
// };
// export const getWorkStations = async (): Promise<any> => {
//   const response = await privateRequest.get(
//     `${ENDPOINTS.USER_WORKSTATION}?From=1&To=-1&Search=&IsActive=true
// `
//   );
//   return response;
// };

// export const getUsersData = async(data: UserData) : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.USER_DATA}`, { params: data });
//   return res.data;
// }

// export const getAssignTeam = async(payload : any) : Promise<any> => {
//   const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_TEAM}`,payload)
//   return res.data;
// }

// export const getCountryList = async() : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.COUNTRY_LIST}`)
//   return res.data;
// }

// export const getManagerList = async(data: any) : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.USER_DATA}`, { params: data });
//   return res.data;
// }

// export const getDepartmentList = async(data : any) : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.DEPARTMENT_LIST}`,{params : data});
//   return res.data;
// }

// export const getDesignationList = async(data : any) : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.DESIGNATION_LIST}`,{params : data});
//   return res.data;
// }

// export const getBranchList = async(data : any) : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.BRANCH_LIST}`,{params : data});
//   return res.data;
// }

// export const getRolesList = async() : Promise<any> => {
//   const res = await privateRequest.get(`${ENDPOINTS.ROLES}`);
//   return res.data;
// }

// export const addUserdetails = async(data : any) :Promise<any> =>{
//    const res = await privateRequest.post(`${ENDPOINTS.USER_DETAILS}`,data);
//    return res
// }

// export const getNotTeamMemberList = async(payload : any) : Promise<any>  => {
//   const res = await privateRequest.post(`${ENDPOINTS.NOT_TEAM_MEMBER}`,payload);
//   return res
// }

// export const AssignTeam = async(payload : any) : Promise<any> => {
//   const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_TEAM}`,payload);
//   return res.data;
// }

// export const deactivate = async(Id : any) : Promise<any> => {
//   return await privateRequest.put(`api/Users/${Id}/Deactivate`, Id)
// }

// export const removemanger = async(userId : any,managerId : any) : Promise<any> => {
//   return await privateRequest.put(`api/Users/${userId}/DeleteManager/${managerId}`)
// }

// export const assignManager = async(payload : any) : Promise<any> => {
//   const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_MANAGER}`,payload)
//   return res.data
// }

const UserService = {
  // getUsersSetting,
  // getUserGlobalSetting,
  // checkout,
  // Checkin,
  // getWorkStations,
  // getUsersData,
  // getAssignTeam,
  // getCountryList,
  // getManagerList,
  // getDepartmentList,
  // getDesignationList,
  // getBranchList,
  // getRolesList,
  // addUserdetails,
  // getNotTeamMemberList,
  // deactivate,
  // removemanger,
  // AssignTeam,
  // assignManager
};

export default UserService;
export type { User };
